import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 10px;
  @media (min-width: 1100px) {
    flex-direction: row;
    align-items: center;
  }
`;

export const ButtonContainer = styled.div`
  margin-bottom: 8px;
  @media (min-width: 1100px) {
    margin-bottom: 0px;
  }
`;

export const ControlsContainer = styled.div.attrs(() => ({}))<{ visible: boolean }>`
  max-height: ${(props) => (props.visible ? '200px' : '0px')};
  opacity: ${(props) => (props.visible ? '1' : '0')};
  transition: 0.5s;
  overflow: ${(props) => (props.visible ? 'visible' : 'hidden')};
  width: 100%;
  @media (min-width: 640px) {
    max-height: unset;
    opacity: 1;
    overflow: visible;
  }
`;

export const FilterIcon = styled.img`
  width: 32px;
  height: 32px;
  flex: none;
  margin: 10px 0px;
`;
